function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_439",
  "data-name": "Group 439",
  transform: "translate(-320 -1402)"
}, React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(320 1402)"
}), React.createElement("circle", {
  id: "Ellipse_32-2",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(358 1402)"
}), React.createElement("circle", {
  id: "Ellipse_32-3",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(396 1402)"
}), React.createElement("circle", {
  id: "Ellipse_32-4",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(434 1402)"
}), React.createElement("circle", {
  id: "Ellipse_32-5",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(472 1402)"
}), React.createElement("circle", {
  id: "Ellipse_32-6",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(510 1402)"
}), React.createElement("circle", {
  id: "Ellipse_32-7",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(320 1440)"
}), React.createElement("circle", {
  id: "Ellipse_32-8",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(358 1440)"
}), React.createElement("circle", {
  id: "Ellipse_32-9",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(396 1440)"
}), React.createElement("circle", {
  id: "Ellipse_32-10",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(434 1440)"
}), React.createElement("circle", {
  id: "Ellipse_32-11",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(472 1440)"
}), React.createElement("circle", {
  id: "Ellipse_32-12",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(510 1440)"
}), React.createElement("circle", {
  id: "Ellipse_32-13",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(320 1478)"
}), React.createElement("circle", {
  id: "Ellipse_32-14",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(358 1478)"
}), React.createElement("circle", {
  id: "Ellipse_32-15",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(396 1478)"
}), React.createElement("circle", {
  id: "Ellipse_32-16",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(434 1478)"
}), React.createElement("circle", {
  id: "Ellipse_32-17",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(472 1478)"
}), React.createElement("circle", {
  id: "Ellipse_32-18",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(510 1478)"
}), React.createElement("circle", {
  id: "Ellipse_32-19",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(320 1516)"
}), React.createElement("circle", {
  id: "Ellipse_32-20",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(358 1516)"
}), React.createElement("circle", {
  id: "Ellipse_32-21",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(396 1516)"
}), React.createElement("circle", {
  id: "Ellipse_32-22",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(434 1516)"
}), React.createElement("circle", {
  id: "Ellipse_32-23",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(472 1516)"
}), React.createElement("circle", {
  id: "Ellipse_32-24",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(510 1516)"
}), React.createElement("circle", {
  id: "Ellipse_32-25",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(320 1554)"
}), React.createElement("circle", {
  id: "Ellipse_32-26",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(358 1554)"
}), React.createElement("circle", {
  id: "Ellipse_32-27",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(396 1554)"
}), React.createElement("circle", {
  id: "Ellipse_32-28",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(434 1554)"
}), React.createElement("circle", {
  id: "Ellipse_32-29",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(472 1554)"
}), React.createElement("circle", {
  id: "Ellipse_32-30",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(510 1554)"
}), React.createElement("circle", {
  id: "Ellipse_32-31",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(320 1592)"
}), React.createElement("circle", {
  id: "Ellipse_32-32",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(358 1592)"
}), React.createElement("circle", {
  id: "Ellipse_32-33",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(396 1592)"
}), React.createElement("circle", {
  id: "Ellipse_32-34",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(434 1592)"
}), React.createElement("circle", {
  id: "Ellipse_32-35",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(472 1592)"
}), React.createElement("circle", {
  id: "Ellipse_32-36",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(510 1592)"
}), React.createElement("g", {
  id: "Group_431",
  "data-name": "Group 431",
  transform: "translate(-1288.054 396.206)"
}, React.createElement("path", {
  id: "Path_973",
  "data-name": "Path 973",
  d: "M1675.354,1076a26.2,26.2,0,1,1,51.652,6.264",
  transform: "translate(9.986 8.298)",
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("ellipse", {
  id: "Ellipse_1207",
  "data-name": "Ellipse 1207",
  cx: 13.5,
  cy: 13.5,
  rx: 13.5,
  ry: 13.5,
  transform: "translate(1682.863 1147.08)",
  fill: "#5603ad"
}), React.createElement("ellipse", {
  id: "Ellipse_1208",
  "data-name": "Ellipse 1208",
  cx: 13.5,
  cy: 13.5,
  rx: 13.5,
  ry: 13.5,
  transform: "translate(1682.863 1110.96)",
  fill: "#937ef8"
}), React.createElement("ellipse", {
  id: "Ellipse_1209",
  "data-name": "Ellipse 1209",
  cx: 13.5,
  cy: 13.5,
  rx: 13.5,
  ry: 13.5,
  transform: "translate(1648.432 1110.96)",
  fill: "#ff525f"
}), React.createElement("path", {
  id: "Path_974",
  "data-name": "Path 974",
  d: "M1666.932,1077.593a29.366,29.366,0,1,0,25.646,32.665,28.952,28.952,0,0,0-.073-7.4",
  transform: "translate(0 17.818)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "Path_975",
  "data-name": "Path 975",
  d: "M1712.1,1078.314a32.742,32.742,0,0,0-7.422-1.786c-18.126-2.181-33.871,8.547-36.269,28.476a32.074,32.074,0,0,0,.081,8.219",
  transform: "translate(-4.916 14.365)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "Path_976",
  "data-name": "Path 976",
  d: "M1688.728,1138.026a32.1,32.1,0,0,0,7.373,1.8,32.615,32.615,0,0,0,33.552-45.94",
  transform: "translate(12.167 22.571)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "Path_977",
  "data-name": "Path 977",
  d: "M1714.262,1119.265a27.235,27.235,0,1,1,17.509,12.9",
  transform: "translate(18.925 16.729)",
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgEegAndQeeg = function SvgEegAndQeeg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEegAndQeeg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eeg-and-qeeg.a2a5e7fa.svg";
export { ForwardRef as ReactComponent };